export const iconFontAwesomeSportsFitnessPersonSkating = (
	<i className="fa-solid fa-person-skating"></i>
);
